import { MapLayerInterface } from "./interfaces";

export const combineLayersList = (
  oldLayers: MapLayerInterface[],
  newLayers: any
) => {
  let combinedArray = [...oldLayers, ...newLayers].reduce((acc, obj) => {
    acc[obj.alias] = {
      ...obj
    };
    return acc;
  }, {});
  combinedArray = Object.values(combinedArray);
  return combinedArray;
};

export const combineProviderList = (oldProviders: any, newProviders: any) => {
  if (!newProviders) return [];

  const oldProviderObjectById = oldProviders.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {});

  const combinedArray = newProviders.map((item) => ({
    ...item,
    ...oldProviderObjectById[item.id],
    index: item.index
  }));

  return combinedArray;
};

export const combineProvidersStatusesList = (
  oldProviders: any,
  newStatuses: any
) => {
  if (!newStatuses) return oldProviders;

  const newStatusesObjectById = newStatuses.reduce((acc, item) => {
    acc[item.data.provider_id] = item;
    return acc;
  }, {});

  const combinedArray = oldProviders.map((item) => ({
    ...item,
    inference: {
      ...item.inference,
      ...newStatusesObjectById[item.id]
    },
    isInferenceStatusWaiting: false
  }));

  return combinedArray;
};
